import { FC, ReactElement } from 'react';
import * as Styled from './tech-ability-single-plank.styles';

interface TechAbilitySinglePlankProps {
    icon: ReactElement;
    text: string;
    hasSpinner?: boolean;
}

export const TechAbilitySinglePlank: FC<TechAbilitySinglePlankProps> = ({ icon, text, hasSpinner }) => (
    <Styled.TechAbilityPlank>
        <Styled.Content>
            {hasSpinner ? (
                <Styled.SpinnerWrapper>{icon}</Styled.SpinnerWrapper>
            ) : (
                <Styled.IconWrapper>{icon}</Styled.IconWrapper>
            )}
            <Styled.TextPlank>{text}</Styled.TextPlank>
        </Styled.Content>
    </Styled.TechAbilityPlank>
);
